import { useOidcStore } from "vue3-oidc";
import { globalEnv } from "@/constants.js";
import { Configuration as SspConfiguration } from "@socotec.io/ssp-back-sdk";
import { projectIdMiddleware, restApiErrorMiddleware } from "@/api/restMiddleware";
import { Configuration as ContributorsConfiguration } from "@socotec.io/contributors-sdk";
import { Configuration as DocumentConfiguration } from "@socotec.io/document-sdk";
import { Configuration as AtlasConfiguration } from "@socotec.io/atlas-as-a-service-sdk";
import { Configuration as ReportGeneratorConfiguration } from "@socotec.io/report-generator-sdk";
import { Configuration as MaterialsConfiguration } from "@socotec.io/materials-sdk";

const tokenGetter = () => useOidcStore().state.value.token;

export const sspConfig = new SspConfiguration({
  basePath: globalEnv.apiBasePath,
  accessToken: tokenGetter,
  fetchApi: fetch,
  middleware: [restApiErrorMiddleware],
});

export const sspProjectConfig = new SspConfiguration({
  basePath: globalEnv.apiBasePath,
  accessToken: tokenGetter,
  fetchApi: fetch,
  middleware: [projectIdMiddleware, restApiErrorMiddleware],
});

export const contributorsConfig = new ContributorsConfiguration({
  basePath: globalEnv.contributorsRestApiUrl,
  accessToken: tokenGetter,
  fetchApi: fetch,
});

export const documentConfig = new DocumentConfiguration({
  basePath: globalEnv.documentRestApiUrl,
  accessToken: tokenGetter,
});

export const pulConfig = new DocumentConfiguration({
  basePath: globalEnv.pulRestApiUrl,
  accessToken: tokenGetter,
});

export const atlasConfig = new AtlasConfiguration({
  basePath: globalEnv.atlasRestApiUrl,
  accessToken: tokenGetter,
});

export const materialsConfig = new MaterialsConfiguration({
  basePath: globalEnv.materialsRestApiUrl,
  accessToken: tokenGetter,
});

export const reportGeneratorConfig = new ReportGeneratorConfiguration({
  basePath: globalEnv.reportGeneratorRestApiUrl,
  accessToken: tokenGetter,
  fetchApi: fetch,
});
